import React, { useEffect } from "react";
import "styles/base.scss";
import { Background } from "components";
import { Midline } from "components";
import { ImageSection } from "components";
import { TitleYear } from "components";
import { VideoSection } from "components";
import Data from "data/data.json";
import LocomotiveScroll from "locomotive-scroll";

const number = (number: number, min: number, max: number) => {
  return Math.min(max, Math.max(min, number));
};

function closeModel() {
  const modelCon: any = document.querySelector(".videoModel__con");
  modelCon.querySelector("video").src = "";
  modelCon.style.opacity = `0`;
  modelCon.style.pointerEvents = `none`;
  modelCon.querySelector(
    "video"
  ).style.transform = `translate(-50%, -50%) scale(0)`;
}

function Model() {
  return (
    <div className="videoModel__con">
      <video id="mainVideo" src=""></video>
      <div
        onClick={() => {
          closeModel();
        }}
        className="x__con --videoModel"
      >
        X
      </div>
    </div>
  );
}

const isVideoPlaying = (video: any) =>
  !!(
    video.currentTime > 0 &&
    !video.paused &&
    !video.ended &&
    video.readyState > 2
  );

const userAgent = navigator.userAgent;

function App() {
  useEffect(() => {
    /**
     * refresh timer
     * refreshes page after a minute of not being used.
     */

    if (/android/i.test(userAgent) || /iPad|iPhone|iPod/i.test(userAgent)) {
    } else {
      (function () {
        const idleDurationSecs = 60; // X number of seconds
        const redirectUrl = "./"; // Redirect idle users to this URL
        let idleTimeout: any; // variable to hold the timeout, do not modify

        const resetIdleTimeout = function () {
          // Clears the existing timeout
          if (idleTimeout) clearTimeout(idleTimeout);

          // Set a new idle timeout to load the redirectUrl after idleDurationSecs
          idleTimeout = setTimeout(
            () => document.location.reload(),
            idleDurationSecs * 1000
          );
        };

        // Init on page load
        resetIdleTimeout();

        setInterval(function () {
          const modelCon: any = document.querySelector(".videoModel__con");
          if (isVideoPlaying(modelCon.querySelector("video"))) {
            resetIdleTimeout();
          }
        }, 3000);

        // Reset the idle timeout on any of the events listed below
        ["click", "touchstart", "mousemove"].forEach((evt) =>
          document.addEventListener(evt, resetIdleTimeout, false)
        );
      })();
    }

    /**
     * scroll init
     */

    const scroll = new LocomotiveScroll({
      el: document.querySelector("[data-scroll-container]"),
      smooth: true,
      repeat: true,
      smartphone: {
        repeat: false,
      },
    });

    /**
     * attempt to fix a scrolling bug
     */
    setTimeout(() => {
      scroll.update();
    }, 300);

    window.addEventListener("load", (event) => {
      setTimeout(() => {
        scroll.update();
      }, 100);
    });

    const yearTitles: any = document.querySelectorAll(".titleYear__con");

    scroll.on("scroll", (obj: any) => {
      let topView: number = scroll.scroll.instance.scroll.y;
      let midView: number = topView + window.innerHeight / 2;

      // console.log(obj.currentElements.el);

      yearTitles.forEach((title: any) => {
        const sectionTop: number = title.offsetTop;
        const sectionMid: number = sectionTop + title.offsetHeight / 2;
        let distanceToSection: number = midView - sectionMid;

        let distaceInvert = distanceToSection * -1;
        let distaceInvert10th = distanceToSection * 0.001 + 1;
        let distaceInvert10thneg = distanceToSection * -0.1;

        title.querySelector(
          ".letterSpan__con"
        ).style.transform = `scale(${number(distaceInvert10th, 0.2, 1)})
          rotateX(${number(distaceInvert10thneg, 0, 90)}deg)
          `;
        title.querySelector(".letterSpan__con").style.opacity = `    ${number(
          distaceInvert10th,
          0,
          1
        )}   `;
      });
    });

    setTimeout(function () {
      scroll.update();
    }, 300);
  });
  return (
    <>
      <div data-scroll-container>
        <div data-scroll-section>
          <Background />
          <section className="mainContent__con">
            <Midline></Midline>
            <header>
              <div>
                <h1>Homestead History Experience</h1>
              </div>
              <div className="subtitle"> We start here</div>
            </header>

            {/* content starts here */}

            <TitleYear word="Long Ago" />
            <ImageSection
              obj={[
                Data.Sheet1[0],
                Data.Sheet1[1],
                Data.Sheet1[2],
                Data.Sheet1[3],
              ]}
            />

            <TitleYear word="1900" />
            <VideoSection
              obj={[Data.Sheet1[4], Data.Sheet1[5], Data.Sheet1[6]]}
            />
            <ImageSection
              obj={[
                Data.Sheet1[7],
                Data.Sheet1[8],
                Data.Sheet1[9],
                Data.Sheet1[10],
              ]}
            />

            <VideoSection obj={[Data.Sheet1[11], Data.Sheet1[12]]} />
            <ImageSection
              obj={[
                Data.Sheet1[13],
                Data.Sheet1[14],
                Data.Sheet1[15],
                Data.Sheet1[16],
              ]}
            />

            <TitleYear word="1920" />
            <ImageSection obj={[Data.Sheet1[17], Data.Sheet1[18]]} />
            <VideoSection obj={[Data.Sheet1[19], Data.Sheet1[20]]} />
            <ImageSection obj={[Data.Sheet1[21], Data.Sheet1[22]]} />
            <VideoSection obj={[Data.Sheet1[23], Data.Sheet1[24]]} />
            <TitleYear word="1930" />
            <ImageSection obj={[Data.Sheet1[25], Data.Sheet1[26]]} />

            <TitleYear word="1940" />
            <VideoSection obj={[Data.Sheet1[27], Data.Sheet1[28]]} />

            <ImageSection
              obj={[
                Data.Sheet1[29],
                Data.Sheet1[30],
                Data.Sheet1[31],
                Data.Sheet1[32],
              ]}
            />
            <TitleYear word="1950" />
            <VideoSection obj={[Data.Sheet1[33], Data.Sheet1[34]]} />
            <TitleYear word="1960" />
            <ImageSection
              obj={[
                Data.Sheet1[35],
                Data.Sheet1[36],
                Data.Sheet1[37],
                Data.Sheet1[38],
              ]}
            />
            <VideoSection obj={[Data.Sheet1[39]]} />
            <TitleYear word="1970" />

            <ImageSection
              obj={[
                Data.Sheet1[40],
                Data.Sheet1[41],
                Data.Sheet1[42],
                Data.Sheet1[43],
              ]}
            />

            <TitleYear word="1990" />
            <VideoSection
              obj={[Data.Sheet1[44], Data.Sheet1[45], Data.Sheet1[46]]}
            />
            <TitleYear word="2000" />
            <ImageSection obj={[Data.Sheet1[47], Data.Sheet1[48]]} />
            <VideoSection obj={[Data.Sheet1[49], Data.Sheet1[50]]} />

            <ImageSection obj={[Data.Sheet1[51], Data.Sheet1[52]]} />

            <footer> </footer>
          </section>
        </div>
      </div>

      <Model />
    </>
  );
}

export default App;
